"use client";

import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function TurnAiIntoMeasurableBusinessOutcomes() {
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 30;
      const y = (e.clientY / window.innerHeight - 0.5) * 30;
      setMousePosition({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section data-section-id="223661" id="turn-ai-into-measurable-business-outcomes" className="bg-background text-foreground relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-blue-50 to-white" style={{
    perspective: "1000px"
  }}>
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
          @keyframes flyGlow {
            0%, 100% { 
              text-shadow: 0 0 20px hsl(var(--chart-1) / 0.2), 0 0 40px hsl(var(--chart-1) / 0.1);
              transform: scale(1) translateY(0);
            }
            50% { 
              text-shadow: 0 0 30px hsl(var(--chart-1) / 0.4), 0 0 60px hsl(var(--chart-1) / 0.2);
              transform: scale(1.01) translateY(-5px);
            }
          }
          .animate-float {
            animation: float 6s ease-in-out infinite;
          }
          .animate-fly-glow {
            animation: flyGlow 4s ease-in-out infinite;
          }
        `
    }} />

      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-0 transition-transform duration-300 ease-out" style={{
      transform: `rotateX(${-mousePosition.y}deg) rotateY(${mousePosition.x}deg) scale(1.1)`
    }}>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686539/img/abstract_data_network_bg.png" alt="" className="w-[120vw] md:w-[80vw] max-w-[1000px] object-contain opacity-10 blur-[1px]" aria-hidden="true" />
      </div>

      <div className="container mx-auto px-4 py-24 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          
          {}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left space-y-12">
            <div className="space-y-6">
              <h1 className="font-default text-7xl md:text-8xl lg:text-[80px] leading-[1.1] tracking-tighter font-extrabold text-foreground">
                Turn <span className="text-chart-1">AI</span> Into <span className="text-chart-1">Measurable</span> Business Outcomes
              </h1>
              <p className="text-xl md:text-2xl font-default text-muted-foreground leading-relaxed max-w-2xl">
                We help businesses identify high-value workflows, enable employees, automate repetitive work, and build a scalable AI operating model.
              </p>
            </div>
            
            <div className="pt-8 flex flex-col sm:flex-row gap-4">
              <Link to="/ConnectPage">
                <Button size="lg" className="h-14 px-8 text-lg font-semibold tracking-normal rounded-lg bg-chart-1 hover:bg-secondary text-white shadow-md transition-all duration-300 group">
                  Get Started
                  <ArrowRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <Link to="/ServicesPage">
                <Button variant="outline" size="lg" className="h-14 px-8 text-lg font-semibold tracking-normal rounded-lg border-chart-1 text-chart-1 hover:bg-accent transition-all duration-300">
                  Watch Process
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="relative w-full max-w-lg mx-auto lg:max-w-none animate-float">
            {}
            <div className="absolute -inset-4 bg-chart-1/10 blur-[60px] rounded-lg z-0 pointer-events-none"></div>
            <div className="absolute -inset-1 bg-chart-2/5 blur-[30px] rounded-3xl z-0 pointer-events-none"></div>
            
            {}
            <div className="relative z-10 rounded-lg overflow-hidden border border-border bg-card/50 backdrop-blur-md shadow-xl aspect-[4/5] md:aspect-square lg:aspect-[4/5]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686539/img/ai_outcome_graph_3d.png" alt="AI Outcome Trends Graph" className="w-full h-full object-cover object-center opacity-90" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-white/40 via-transparent to-transparent pointer-events-none"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}